import { render, staticRenderFns } from "./LeadBoardColumnNavigation.vue?vue&type=template&id=59ec14f4&"
import script from "./LeadBoardColumnNavigation.vue?vue&type=script&lang=js&"
export * from "./LeadBoardColumnNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports